import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { Input } from '@/components/ui/Input';
import { Textarea } from '@/components/ui/Textarea';
import { Select } from '@/components/ui/Select';
import { t } from '@/lib/i18n';
import type { MultiSelectOption } from '@/components/ui/MultiSelect';
import type { EditorState } from '../roleContractEditorState';
import { NOT_SET } from '../roleContractEditorState';

interface Props {
  state: EditorState;
  setState: React.Dispatch<React.SetStateAction<EditorState>>;
  actorOptions: MultiSelectOption[];
}

export function PurposeSection({ state, setState, actorOptions }: Props) {
  return (
    <Card>
      <CardHeader><CardTitle>{t('Purpose & Scope')}</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        <Input
          label={t('Name')}
          required
          value={state.name}
          onChange={(e) => setState((s) => ({ ...s, name: e.target.value }))}
          data-testid="role-contract-name-input"
        />
        <Select
          label={t('Linked actor (optional)')}
          value={state.actorId || NOT_SET}
          onValueChange={(v) => setState((s) => ({ ...s, actorId: v === NOT_SET ? '' : v }))}
          options={[{ value: NOT_SET, label: t('— not linked —') }, ...actorOptions.map(o => ({ value: o.value, label: o.label }))]}
        />
        <Textarea
          label={t('Purpose scope')}
          value={state.purposeScope}
          onChange={(e) => setState((s) => ({ ...s, purposeScope: e.target.value }))}
          rows={6}
          placeholder={t('Why does this role exist? What outcomes does it own? Mention "draft outcomes" if it should be allowed to draft Outcomes via AI.')}
          data-testid="role-contract-purpose-input"
        />
      </CardContent>
    </Card>
  );
}
